import ozFiltersApplied from './oz-filters-applied.vue'

export default ozFiltersApplied
